import React, { useMemo, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

import calendar from "../../assets/images/icons/calendar.svg"
import * as Yup from "yup"
import { useFormik } from "formik"
import "flatpickr/dist/themes/material_blue.css"
import FlatPickr from "react-flatpickr"
import TableContainer from "components/Common/TableContainer"
import { Link } from "react-router-dom"
import avatar from "../../assets/images/avatar.png"
import arrowDown from "../../assets/images/icons/arrow-down.svg"
import eye from "../../assets/images/icons/eye.svg"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"

const TrackTotalFundsRaised = () => {
  const validation = useFormik({
    initialValues: {
      investment_amount: "",
      tenure: "",
      interest_rate: "",
      fund_requirement_date: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {},
  })
  const defaultFilters = {
    search: "",
    page: 1,
    pageSize: 20,
    timestamp: "",
  }

  const handleUserClick = () => {
    setOpen(true)
    setEditdetails(null)
  }

  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([
    {
      name: "Rajat Bansal",
      email: "rajat.bansal@prachay.in",
      Investor: "ICDR1001",
      amount: "₹5,00,000",
      Investment: "9.25%",
      LastUpdated: "12 mo",
    },
    {
      name: "Neha Kapoor",
      email: "neha.kapoor@prachay.in",
      Investor: "ICDR1001",
      amount: "₹5,00,000",
      Investment: "9.25%",
      LastUpdated: "12 mo",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      Investor: "ICDR1001",
      amount: "₹5,00,000",
      Investment: "9.25%",
      LastUpdated: "12 mo",
    },
    {
      name: "Arvind Chauhan",
      email: "arvind.ch@capitalrise.in",
      Investor: "ICDR1001",
      amount: "₹5,00,000",
      Investment: "9.25%",
      LastUpdated: "12 mo",
    },
  ])

  const columns = useMemo(
    () => [
      {
        header: "Investor Detail",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original.email}
            name={row?.original.name}
          />
        ),
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Investor ID <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Investor",
        enableColumnFilter: false,
        enableSorting: true,

        cell: ({ row }) => (
          <div className="code-number">{row?.original.Investor}</div>
        ),
      },

      {
        header: () => (
          <div className="flex items-center gap-2">
            Amount (₹) <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Investment Type <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "Investment",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Last Updated <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "LastUpdated",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        id: "action",
        header: "",
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="action-view">
              <Link to={"#"}>
                <img src={eye} alt="" />
              </Link>
            </div>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Track Total Funds Raised"}
            breadcrumbItem={"Track Total Funds Raised"}
          />
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4">
            <div>
              <div className="input-wrapper">
                <FlatPickr
                  id="fund_requirement_date"
                  name="fund_requirement_date"
                  className="form-control "
                  placeholder="Jan 10, 2025 – Jan 16, 2025"
                  options={{
                    dateFormat: "d M,Y",
                  }}
                  selected={validation.values.fund_requirement_date}
                  value={validation.values.fund_requirement_date}
                  onChange={(date) => {
                    validation.setFieldValue("fund_requirement_date", date[0])
                  }}
                />
                <img src={calendar} alt="" />
              </div>
            </div>
            <div className="download-link">
              <p>PDF</p>
              <p>CSV</p>
            </div>
          </div>
          <div className="card-reports-wrapper">
            <Col xl={12}>
              <div className="label-header">
                <i className="icon-icd"></i> <p>ICDs Summary</p>
              </div>
            </Col>
            <Row>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total ICDs Investment</h3>
                  <h5>150.4k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Interest Disbursed</h3>
                  <h5>150.5k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total No. of ICDs</h3>
                  <h5>2.1k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Rejected ICDs</h3>
                  <h5>125</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Pending ICDs</h3>
                  <h5>54</h5>
                </div>
              </Col>
            </Row>

            <Col xl={12}>
              <div className="label-header">
                <i className="icon-ul-bonds"></i>
                <p>Bond Investments Summary</p>
              </div>
            </Col>
            <Row>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Bond Investments</h3>
                  <h5>150.4k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Interest Disbursed</h3>
                  <h5>150.5k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total No. of Bonds</h3>
                  <h5>2.1k</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Rejected Bonds</h3>
                  <h5>125</h5>
                </div>
              </Col>
              <Col xl={4}>
                <div className="card-box">
                  <h3>Total Pending Bonds</h3>
                  <h5>54</h5>
                </div>
              </Col>
            </Row>
          </div>
          <div className="my-3">
            <TableContainer
              filters={filters}
              setFilters={setFilters}
              columns={columns}
              data={data}
              buttonName={"Invite"}
              isGlobalFilter={false}
              isCustomPageSize={false}
              handleUserClick={handleUserClick}
              isPagination={true}
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers"
              tableClass="table-bordered   table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TrackTotalFundsRaised
